import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Profe Carolina Giménez',
    location: 'Rosario',
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
    text: 'Increíble el tiempo que me ahorra este manual. Las diapositivas están perfectas y las actividades son súper dinámicas. Mis alumnos están mucho más participativos.'
  }, {
    name: 'Lucía Fernández',
    location: 'CABA',
    avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
    text: 'Antes pasaba horas preparando cada clase. Ahora tengo todo listo y puedo enfocarme en lo importante: enseñar. Las evaluaciones son completas y profesionales.'
  }, {
    name: 'María Belén Sosa',
    location: 'Córdoba',
    avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
    text: 'Lo mejor que me pasó como docente. El contenido es excelente, las actividades son modernas y los trabajos prácticos están listos para usar. Vale cada peso.'
  }, {
    name: 'Andrea Quiroga',
    location: 'Mendoza',
    avatar: 'https://randomuser.me/api/portraits/women/67.jpg',
    text: 'Mis clases cambiaron completamente. Los chicos prestan más atención con las diapositivas y las actividades interactivas. Ya no improviso nada, todo está organizado.'
  }, {
    name: 'Profesora Romina Acuña',
    location: 'La Plata',
    avatar: 'https://randomuser.me/api/portraits/women/52.jpg',
    text: 'Compré el manual y no puedo creer lo completo que es. Teoría desarrollada, evaluaciones listas, todo pensado para el aula real. Lo recomiendo 100%.'
  }, {
    name: 'Verónica Ledesma',
    location: 'Tucumán',
    avatar: 'https://randomuser.me/api/portraits/women/19.jpg',
    text: 'Excelente inversión. Ya no pierdo noches armando material. Las diapositivas son modernas y visuales, y las consignas están súper claras. Mis clases son mucho más dinámicas.'
  }, {
    name: 'Marcelo Ibarra',
    location: 'Salta',
    avatar: 'https://randomuser.me/api/portraits/men/42.jpg',
    text: 'Como docente varón en secundaria, este sistema me facilitó muchísimo el trabajo. Todo está pensado pedagógicamente y listo para usar. Ahorro horas cada semana.'
  }, {
    name: 'Soledad Pereyra',
    location: 'Mar del Plata',
    avatar: 'https://randomuser.me/api/portraits/women/71.jpg',
    text: 'Lo uso todos los días. Las actividades son entretenidas, las evaluaciones están completas y el contenido es realmente útil. Mis alumnos aprenden mejor y yo trabajo menos.'
  }];
  return <section className="py-16 md:py-24 bg-white pt-[30px] pb-[30px]" data-id="element-222">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-224">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-[#1F3A5F] font-oswald uppercase tracking-wide" data-id="element-225">
            ⭐ LO QUE DICEN LOS DOCENTES
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-226">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-[#FAF7F2] rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-227">
                <div className="flex items-center gap-4 mb-4" data-id="element-228">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#1F3A5F] p-0.5 bg-white" data-id="element-229" />
                  <div data-id="element-230">
                    <p className="font-bold text-[#1F3A5F] text-sm leading-tight" data-id="element-231">
                      {testimonial.name}
                    </p>
                    <p className="text-gray-500 text-xs mt-0.5" data-id="element-232">
                      {testimonial.location}
                    </p>
                    <div className="flex gap-0.5 mt-1" data-id="element-233">
                      {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-[#F59E0B] text-[#F59E0B]" data-id="element-234" />)}
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 font-playfair italic text-sm flex-grow" data-id="element-235">
                  "{testimonial.text}"
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}